<div class="lista-home" [ngStyle]="{'background': getBackground(), 'border': getBorder(), 'width': getSize()}"
  [ngClass]="{
    'tamanho-1-margem': config.tamanho == 1 && config.margem == 1,
    'tamanho-1-sem-margem': config.tamanho == 1 && config.margem == 0,
    'tamanho-2-margem': config.tamanho == 2 && config.margem == 1,
    'tamanho-2-sem-margem': config.tamanho == 2 && config.margem == 0,
    'margem': config.margem == 1,
    'margin-right': config.tamanho == 1 && config.ordem == 1 && config.margem == 1,
    'margin-left': config.tamanho == 1 && config.ordem == 2 && config.margem == 1
  }">

  <a class="a-app-card" [ngStyle]="{'width': getSize(), 'text-align' : getFontAlign()}">
    <span [ngStyle]="{'font-size': getFontSize(), 'color': getFontColor()}" [ngClass]="{
        'bottom-left': config.font_align == 'left',
        'centered': config.font_align == 'center',
        'centered-left': config.font_align == 'center-left',
        'negrito-1' : config.negrito == 1,
        'negrito-2' : config.negrito == 2,
        'negrito-3' : config.negrito == 3
      }"
      class="span-app-card">
      {{config.label}}

      <ion-badge
        *ngIf="!userProvider.isAnonimo() && config.target_url == 'MensagemPage' && mensagemProvider.getTotalMensagensNaoLidas() != 0"
        color="danger">
        {{mensagemProvider.getTotalMensagensNaoLidas()}}
      </ion-badge>
      
      <ion-badge
        *ngIf="!userProvider.isAnonimo() && config.target_url == 'OracaoPage' && oracaoProvider.getAdminTotal() != 0"
        color="danger">
        {{oracaoProvider.getAdminTotal()}}
      </ion-badge>

      <ion-badge
        *ngIf="!userProvider.isAnonimo() && config.target_url == 'NoticiaPage' && noticiaProvider.getTotalNaoLidas() != '0'"
        color="danger">
        {{noticiaProvider.getTotalNaoLidas()}}
      </ion-badge>

    </span>
  </a>
</div>